import styled from '@emotion/styled'
import dayjs from 'dayjs'
import React, { useContext } from 'react'
import { BaseField } from 'uniforms'
import type { FlyerMarkKey, FlyerMarks, FlyerMarkStrength } from '../../../api/events/flyerPrefill'

// What a flyer filled in on the new-event form (CVL-177), for the person to check: a marker on
// each field it filled, "Not on flyer" where it showed no time or venue, the year it assumed,
// and the filled-in date in words. The edit form has no provider, so it shows none of these.

export const FlyerPrefillContext = React.createContext<FlyerMarks | null>(null)

const CHECK = 'From your flyer, please check'
const NOT_ON_FLYER = 'Not on flyer'

export const FlyerCheck: React.FC<{ field: FlyerMarkKey }> = ({ field }) => {
  const strength = useContext(FlyerPrefillContext)?.checks[field]
  if (!strength) return null
  return <Marker $strength={strength}>{CHECK}</Marker>
}

export const NotOnFlyer: React.FC<{ field: 'time' | 'venue' }> = ({ field }) => {
  if (!useContext(FlyerPrefillContext)?.notOnFlyer[field]) return null
  return <Marker $strength="normal">{NOT_ON_FLYER}</Marker>
}

export const FlyerYearNote: React.FC = () => {
  const marks = useContext(FlyerPrefillContext)
  if (!marks?.assumedYear || !marks.checks.year) return null
  return <Marker $strength="normal">Year not on flyer, we assumed {marks.assumedYear}</Marker>
}

// Follows the date as the person changes it.
export const FlyerDateInWords: React.FC = (_props, { uniforms: { model } }) => {
  const marks = useContext(FlyerPrefillContext)
  if (!marks?.dateFilled || !model.startAtDate) return null
  return <DateInWords>{dayjs(model.startAtDate).format('dddd, MMMM D, YYYY')}</DateInWords>
}
FlyerDateInWords.contextTypes = BaseField.contextTypes

const Marker = styled.span<{ $strength: FlyerMarkStrength }>`
  display: inline-block;
  margin: 4px 0 8px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
  color: #92400e;
  background: ${props => (props.$strength === 'low' ? '#fde68a' : '#fef3c7')};
  border: 1px solid ${props => (props.$strength === 'low' ? '#d97706' : '#fde68a')};
  font-weight: ${props => (props.$strength === 'low' ? 600 : 'normal')};
`

const DateInWords = styled.div`
  margin: 4px 0;
  font-size: 14px;
  color: #434343;
`
